// 通用属性值

// 来源
export const source = "官网";
// 语言
interface LanguageMap {
  [key: string]: string;
}
export const languageProperties: LanguageMap = {
  zh: "中文",
  en: "英文",
  fr: "法文",
  ru: "俄文",
  es: "西班牙文",
  ar: "阿拉伯文"
};
